import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import apiClient from '../../Config/apiClient';
import { showSuccessToast, showErrorToast } from '../../Context/Toaster/Toaster';


const EmailSettings = () => {
  const [status, setStatus] = useState({ connected: false, email: null });
  const [form, setForm] = useState({ to: '', subject: '', body: '' });
  const [loading, setLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(true);
  const [toastShown, setToastShown] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState('');
  const [recipientName, setRecipientName] = useState('Test User');
  const [previewLoading, setPreviewLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [confirmDisconnect, setConfirmDisconnect] = useState(false);
  const [isDriver, setIsDriver] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await apiClient.get('/api/email/status');
        setStatus(res.data);
      } catch (error) {
        console.error('Failed to load email status', error);
      } finally {
        setStatusLoading(false);
      }
    };

    fetchStatus();
  }, []);

  useEffect(() => {
    if (statusLoading) return;

    const params = new URLSearchParams(location.search);
    const justConnected = params.get('emailConnected') === '1';

    if (justConnected && status.connected && !toastShown) {
      const email = status.email || 'Gmail';
      showSuccessToast(`${email} successfully connected and token stored securely.`);
      setToastShown(true);
    }
  }, [location.search, statusLoading, status, toastShown]);

  useEffect(() => {
    apiClient.get('/api/email/preview/events')
      .then((res) => setEvents(res.data || []))
      .catch((err) => console.error('Failed to load preview events', err));
  }, []);

  const handleConnect = () => {
    const baseURL = apiClient.defaults.baseURL || '';
    window.location.href = `${baseURL || ''}/api/email/connect`;
  };

  const handleDisconnect = async () => {
    try {
      await apiClient.delete('/api/email/disconnect');
      setStatus({ connected: false, email: null });
      setConfirmDisconnect(false);
      showSuccessToast('Gmail account disconnected successfully.');
    } catch (error) {
      console.error('Failed to disconnect Gmail', error);
      showErrorToast('Failed to disconnect Gmail. Please try again.');
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const fetchPreview = async (eventKey, name, driverFlag) => {
    setPreviewLoading(true);
    try {
      const params = new URLSearchParams({
        event: eventKey,
        recipientName: name || 'Test User',
        ...(eventKey === 'hs_account_activation' ? { isDriver: driverFlag ? 'true' : 'false' } : {}),
      });
      const res = await apiClient.get(`/api/email/preview?${params.toString()}`);
      setForm((prev) => ({ ...prev, subject: res.data.subject, body: res.data.html }));
    } catch (err) {
      console.error('Failed to load email preview', err);
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleEventChange = async (event) => {
    const value = event.target.value;
    setSelectedEvent(value);
    setIsDriver(false);
    setForm((prev) => ({ ...prev, subject: '', body: '' }));
    if (!value) return;
    await fetchPreview(value, recipientName, false);
  };

  const handleRecipientNameChange = async (e) => {
    const name = e.target.value;
    setRecipientName(name);
    if (!selectedEvent) return;
    await fetchPreview(selectedEvent, name, isDriver);
  };

  const handleIsDriverChange = async (e) => {
    const checked = e.target.checked;
    setIsDriver(checked);
    if (!selectedEvent) return;
    await fetchPreview(selectedEvent, recipientName, checked);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const res = await apiClient.post('/api/email/send', {
        to: form.to,
        subject: form.subject,
        body: form.body,
      });

      if (res.data && res.data.success) {
        showSuccessToast('Test email sent successfully');
        setForm((prev) => ({ ...prev, to: '' }));
        setSelectedEvent('');
      } else {
        showErrorToast('Failed to send email');
      }
    } catch (error) {
      console.error('Failed to send email', error);
      showErrorToast('Error sending email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="report-wraper">
      <div className="tab-content" id="myTabContent">
        <div className="tab-pane fade show active" id="start" role="tabpanel" aria-labelledby="start-tab">
          <div className="report-tabinner">
            <div className="reportform-cover mt-0">

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <div className="vrt-split" style={{ marginBottom: 0, width: 'auto', float: 'none' }}>
                  <h3>Gmail Settings</h3>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {status.connected && (
                    confirmDisconnect ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '6px', padding: '6px 12px' }}>
                        <span style={{ fontSize: '13px', color: '#856404', marginRight: '4px' }}>Disconnect <strong>{status.email}</strong>?</span>
                        <button
                          type="button"
                          className="cp-button"
                          style={{ position: 'static', float: 'none', background: '#ef4444', borderColor: '#ef4444', padding: '4px 14px', fontSize: '13px' }}
                          onClick={handleDisconnect}
                        >
                          Yes, Disconnect
                        </button>
                        <button
                          type="button"
                          className="cancel-button"
                          style={{ position: 'static', float: 'none', padding: '4px 14px', fontSize: '13px' }}
                          onClick={() => setConfirmDisconnect(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="cp-button"
                        style={{ position: 'static', float: 'none', background: '#ef4444', borderColor: '#ef4444' }}
                        onClick={() => setConfirmDisconnect(true)}
                      >
                        Disconnect Gmail
                      </button>
                    )
                  )}
                  <button
                    type="button"
                    className="cp-button"
                    style={{ position: 'static', float: 'none' }}
                    onClick={handleConnect}
                  >
                    {status.connected ? 'Reconnect Gmail' : 'Connect Gmail'}
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="cp-split">
                    {statusLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                          <span style={{
                            display: 'inline-block',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: status.connected ? '#22c55e' : '#ef4444',
                            flexShrink: 0,
                            boxShadow: status.connected ? '0 0 0 3px rgba(34,197,94,0.2)' : '0 0 0 3px rgba(239,68,68,0.2)',
                          }} />
                          <span style={{ fontWeight: 500, color: status.connected ? '#15803d' : '#b91c1c' }}>
                            {status.connected ? `Connected as ${status.email}` : 'Not connected'}
                          </span>
                        </div>
                        {status.connected && status.updated_at && (
                          <p className="mb-2 small-text" style={{ marginLeft: '18px' }}>
                            Token last updated on {new Date(status.updated_at).toLocaleString()}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <div className="vrt-split" style={{ marginBottom: 0, width: 'auto', float: 'none' }}>
                  <h3>Send Test Email</h3>
                </div>
                <button
                  className="cp-button"
                  type="submit"
                  form="sendTestEmailForm"
                  style={{ position: 'static', float: 'none' }}
                  disabled={loading || !status.connected || !selectedEvent}
                >
                  {loading ? 'Sending...' : 'Send Test Email'}
                </button>
              </div>

              <form id="sendTestEmailForm" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="cp-split">
                      <label className="fi-label">
                        Event <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        name="event"
                        value={selectedEvent}
                        onChange={handleEventChange}
                        className="common-select"
                        required
                      >
                        <option value="">-- Select event to preview template --</option>
                        {events.map((event) => (
                          <option key={event.key} value={event.key}>
                            {event.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="cp-split mt-3">
                      <label className="fi-label">Recipient Name</label>
                      <input
                        type="text"
                        value={recipientName}
                        onChange={handleRecipientNameChange}
                        placeholder="Test User"
                        className="common-input"
                      />
                    </div>

                    {selectedEvent === 'hs_account_activation' && (
                      <div className="cp-split mt-3" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="checkbox"
                          id="previewIsDriver"
                          checked={isDriver}
                          onChange={handleIsDriverChange}
                          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                        />
                        <label htmlFor="previewIsDriver" className="fi-label" style={{ marginBottom: 0, cursor: 'pointer' }}>
                          Admin also signed up as Driver
                        </label>
                      </div>
                    )}

                    <div className="cp-split mt-3">
                      <label className="fi-label">
                        To <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="email"
                        name="to"
                        value={form.to}
                        onChange={handleChange}
                        required
                        className="common-input"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="cp-split">
                      <label className="fi-label">Email Preview</label>
                      {previewLoading ? (
                        <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '16px', background: '#f9fafb', color: '#9ca3af', fontSize: '13px', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Loading preview...
                        </div>
                      ) : selectedEvent && form.body ? (
                        <div
                          style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '6px',
                            padding: '8px',
                            background: '#ffffff',
                            height: '280px',
                            overflowY: 'auto',
                            zoom: 1.25,
                          }}
                          dangerouslySetInnerHTML={{ __html: form.body }}
                        />
                      ) : (
                        <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '16px', background: '#f9fafb', color: '#9ca3af', fontSize: '13px', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Select an event to preview the template
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSettings;
